import React from 'react';
import styled from 'styled-components';
import Logo from './Logo';

const Wrap = styled.div`
  background: #ffdc46;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  & > div {
    width: 40%;
    padding-bottom: 50%;
  }

  #logo {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 40px;
  }

  .progress {
    margin: 20px 2px 0 2px;
    padding-left: 10px;
    height: 10px;
    box-sizing: border-box;
    background: #58d0f2;
    transition: width 0.5s linear;
  }
`;

export default class LoadingScreen extends React.Component {
  state = {
    progress: 0,
  };

  componentDidMount() {
    this.check();
  }

  componentWillUnount() {
    clearTimeout(this.timeout);
  }

  render() {
    return (
      <Wrap>
        <div>
          <Logo />
          <div
            className="progress"
            style={{ width: `${Math.min(1, this.state.progress) * 100}%` }}
          />
        </div>
      </Wrap>
    );
  }

  check = () => {
    const progress = this.props.preloader.getProgress();
    if (progress >= 1) {
      this.props.onDone();
    } else {
      this.setState({ progress });
      this.timeout = setTimeout(this.check, 500);
    }
  };
}
